import { Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

import { StyledFieldset, StyledLoadingFieldsetAdvanced } from './Sections/index.styles';

const StyledLoadingFooter = styled('div')`
    display: flex;
    justify-content: flex-end;
`;

export const LoadingForm: React.FC = () => (
    <>
        <StyledFieldset>
            {[...Array(5).keys()].map((_, index) => (
                <Skeleton width={400} key={index} animation="wave" height={60} />
            ))}
        </StyledFieldset>
        <StyledLoadingFieldsetAdvanced>
            {[...Array(7).keys()].map((_, index) => (
                <Skeleton sx={{ margin: 0, width: '100%' }} key={index} animation="wave" height={60} />
            ))}
        </StyledLoadingFieldsetAdvanced>
        <StyledLoadingFooter>
            <Skeleton width={80} height={60} />
            <Skeleton sx={{ marginLeft: '1rem', marginRight: '0.75rem' }} animation="wave" width={120} height={60} />
        </StyledLoadingFooter>
    </>
);
